export const EntitiesProperties = {
    NOT_NUMERIC: {
        NAME: "name",
        PLATFORM: "platform",
        PAYMENT: "payment",
        ID_UNDERSCORE: "_id",
        MODIFY_DATE: "modifiedDate",
        CREATED_DATE: "createdDate",
        PUBLISHED_DATE: "publishedDate",
        IS_DISPLAY_AS_FREE: "isDisplayableAsFree",
        NAME_UPERCASE: "Name",
        PLATFORM_UPERCASE: "Platform",
        PAYMENT_UPERCASE: "Payment",
        DEMAND_TAG: "demandTag",
        SUPPLY_TAG: "supplyTag",
        DATAPOINT: "dataPoint",
        ADSERVER: "adServer",
        SUPPLY_PARTNER: "supplyPartner",
        DEMAND_PARTNER: "demandPartner",
        CAMPAIGN_ID: "campaignId",
        REVENUE_DIFFERENCE: "revenueDifference",
        PUBLISHER_REVENUE: "publisherRevenue",
        IMPRESSIONS_DIFFERENCE: "impressionsDifference",
        PUBLISHER_IMPRESSIONS: "publisherImpressions"
    },
    // Numeric values.
    NUMERIC: {
        // Can sum them.
        ADDABLE: {
            // Lowercase values.
            IMPRESSIONS: "impressions",
            REQUESTS: "requests",
            OPPORTUNITIES: "opportunities",
            REVENUE: "revenue",
            COST: "cost",
            PROFIT: "profit",
            RATINGS: "ratings",

            // Upercase values.
            REVENUE_UPERCASE: "Revenue",
            OPPORTUNITIES_UPERCASE: "Opportunities",
            IMPRESSIONS_UPERCASE: "Impressions",
            REQUESTS_UPERCASE: "Requests",
            COST_UPPERCASE: "Cost",
            PROFIT_UPPERCASE: "Profit",
        },
        // All the numeric keys.
        ALL: {
            // Lowercase values.
            IMPRESSIONS: "impressions",
            REQUESTS: "requests",
            AD_REQUESTS: "adRequests",
            AD_FILL_RATE: "adFillRate",
            OPPORTUNITIES: "opportunities",
            REVENUE: "revenue",
            FILL: "fill",
            FILL_RATE: "fillRate",
            FILL_RATE_BEACHFRONT_STYLE: "fillRate",
            REVENUE_PRECENT: "revenuePercent",
            CPM: "cpm",
            RPM: "rpm",
            CTR: "ctr",
            VCR: "vcr",
            COST: "cost",
            PROFIT: "profit",
            RATINGS: "ratings",
            PROFIT_PERCENT:'profitPercent',
            NET_COST: 'netCost',
            NET_REVENUE: 'netRevenue',
            NET_PROFIT: 'netProfit',
            COMPLETION: 'completion',
            INCOMING_REQUESTS: 'incomingRequests',
            SERVICE_COST: 'serviceCost',
            SERVING_COST: 'servingCost',
        },
    },
};

export const GRAPHS = {
    TYPES: {
        ACCUMULATE: "accumulate",

        DELTA: "delta",
    },

};
const {VCR,SERVICE_COST, FILL_RATE,REQUESTS,REVENUE,INCOMING_REQUESTS,COST,PROFIT,COMPLETION,IMPRESSIONS,PROFIT_PERCENT,CPM,RPM,NET_REVENUE,NET_PROFIT,NET_COST,AD_FILL_RATE,AD_REQUESTS}=EntitiesProperties.NUMERIC.ALL
export const metricEnumKeyMap = {
    impressions: {label:IMPRESSIONS,value:IMPRESSIONS},
    requests: {label:'Ad Requests',value:AD_REQUESTS},
    adFillRate: {label:'Ad Fill Rate', value: AD_FILL_RATE},
    profit: {label:PROFIT,value:PROFIT},
    revenue: {label:REVENUE,value:REVENUE},
    cost: {label:COST,value:COST},
    profitPercent: {label:PROFIT_PERCENT,value:PROFIT_PERCENT},
    cpm: {label:CPM,value:CPM},
    rpm: {label:RPM,value:RPM},
    vcr: {label:VCR,value:VCR},
    netRevenue: {label:NET_REVENUE,value:NET_REVENUE},
    netCost: {label:NET_COST,value:NET_COST},
    netProfit: {label:NET_PROFIT,value:NET_PROFIT},
    completion: {label:COMPLETION,value:COMPLETION},
    incomingRequests: {label:"Incoming Requests",value:INCOMING_REQUESTS},
    fillRate:{label:"Fill Rate",value:FILL_RATE},
    serviceCost: {label: "Serving Cost", value: SERVICE_COST}
}
